import { render, staticRenderFns } from "./ClassroomForm.vue?vue&type=template&id=4e28e766&scoped=true"
import script from "./ClassroomForm.vue?vue&type=script&lang=js"
export * from "./ClassroomForm.vue?vue&type=script&lang=js"
import style0 from "./ClassroomForm.vue?vue&type=style&index=0&id=4e28e766&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e28e766",
  null
  
)

export default component.exports